import {MarkupBBCodeVariant, MarkupLatexType, MarkupNodeType, SUPPORTED_CODE_LANGS} from '#src/constants.js';
import {createHtmlTag, escapeRegExp, toBase64} from '#src/helper.js';
import {SkipType} from '#src/processing-context.js';

const RESERVED_TAG_NAMES = new Set([
  'b',
  'code',
  'cspoiler',
  'i',
  'l',
  'latex',
  'li',
  'm',
  'n',
  'ol',
  'pre',
  's',
  'spoiler',
  'sub',
  'sup',
  'tooltip',
  'u',
  'ul',
  'url'
]);

const LANGS = SUPPORTED_CODE_LANGS
  .map(lang => escapeRegExp(lang))
  .join('|');
const LANGS_TAG = SUPPORTED_CODE_LANGS
  .filter(lang => !RESERVED_TAG_NAMES.has(lang))
  .map(lang => escapeRegExp(lang))
  .join('|');

const convertCode = (isMarkdown, isShort) => ({matchStart, options, text}) => {
  options.skipType = SkipType.SkipCode;

  const [, lang] = matchStart;

  const variant = !isMarkdown && (isShort ? MarkupBBCodeVariant.Short : MarkupBBCodeVariant.Long);

  const dataset = {'data-text': toBase64(text)};

  if (lang) {
    dataset['data-lang'] = lang;
  }

  return createHtmlTag(MarkupNodeType.Code, dataset, {isMarkdown, variant});
};

const convertLatex = (isMarkdown, isInline) => ({options, text}) => {
  options.skipType = SkipType.SkipHtml;

  return createHtmlTag(MarkupNodeType.Latex, {
    'data-text': toBase64(text),
    'data-type': isInline ? MarkupLatexType.Inline : MarkupLatexType.Block
  }, {isMarkdown});
};

function checkLangsMatch(info, matchs, matche) {
  return matchs && matche && matchs[1] && matchs[1] === matche[1];
}

export default [{
  cl: /\s+\\--/gu,
  convert: convertCode(true),
  op: new RegExp(`/--code\\s+(${LANGS})\\s+`, 'giu'),
  priority: 300
}, {
  convert: convertLatex(true, false),
  op: '$$$',
  priority: 400
}, {
  convert: convertLatex(true, true),
  op: '$$',
  priority: 500
}, {
  cl: '[/code]',
  convert: convertCode(false),
  op: '[code]',
  priority: 800
}, {
  cl: '[/code]',
  convert: convertCode(false, false),
  op: new RegExp(`\\[code\\s+lang="?(${LANGS})"?\\s*\\]`, 'giu'),
  priority: 900
}, {
  check: checkLangsMatch,
  cl: new RegExp(`\\[/(${LANGS_TAG})\\]`, 'giu'),
  convert: convertCode(false, true),
  op: new RegExp(`\\[(${LANGS_TAG})\\]`, 'giu'),
  priority: 1000
}, {
  cl: '[/latex]',
  convert: convertLatex(false, false),
  op: '[latex]',
  priority: 1300
}, {
  cl: '[/l]',
  convert: convertLatex(false, true),
  op: '[l]',
  priority: 1400
}];
